//import Components
import React, { useState } from 'react';
import { Collapse, Row } from 'reactstrap';
import ImageCard from '../ImageCard/ImageCard.component';
import {
  BTN_SEE_MORE,
  BTN_SEE_LESS
} from "../../constants/views/Products/ProductGroups.constant";

let data;
const CollapseComponent = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [btnName, setLess] = useState(BTN_SEE_MORE);
  const toggle = () => {
    setIsOpen(!isOpen);
    setLess(() => {
      if (isOpen) {
        return BTN_SEE_MORE;
      }
      else {
        return BTN_SEE_LESS;
      }
    });
  }

  if (props.type === "recipes") {
    const Recipes = props.recipes;
    data = Recipes[props.group];
  } else if (props.type === "our-products") {
    const Products = props.products;
    data = Products[props.group];
  }

  let length_check_limit = props.start + 1;
  return (
    <div className={props.class}>
      <Collapse isOpen={isOpen}>
        <Row>
          {
            data.map((value, index) => {
              if (index > props.start && index <= data.length)
                return <ImageCard
                  itemTextClass={props.itemTextClass}
                  imgClass={props.imgClass}
                  key={value.slug}
                  imgSrc={value.image} alt={value.alt_text}
                  itemText={value.name}
                  slug={value.slug}
                  item={props.item}
                  type={props.type}></ImageCard>
              else
                return "";
            })
          }
        </Row>
      </Collapse>
      {
        props.length > length_check_limit ?
          <button className={props.btnClass} onClick={toggle}>{btnName}</button>
          :
          <button className={props.btnClass} style={{ visibility: "hidden"}}>{btnName}</button>
      }
    </div>
  );
}

export default CollapseComponent;